import { PromotionServiceId } from '../../components/types/promotion';
import BumpIcon from '../../public/static/images/item/promotion.svg';
import VipIcon from '../../public/static/images/item/vip.svg';
import FeatureIcon from '../../public/static/images/item/feature.svg';

export const getPromotionServiceIcon = (service: string) => {
  switch (true) {
    case service === PromotionServiceId.Bump:
      return [BumpIcon];
    case service === PromotionServiceId.Vip:
      return [VipIcon];
    case service === PromotionServiceId.Feature:
      return [FeatureIcon];
    default:
      return [];
  }
};
